import React, {useEffect} from 'react';
import '../css/Partners.css';
import '../css/PartnersAuth.css';

import {partnersService} from "../_services/partners.service";
import PartnerLoadingSpinner from "../components/partners/PartnerLoadingSpinner";
import { App as AppCapacitorPlugin } from '@capacitor/app';

const Partners = ({partner}) => {
    const queryString = window.location.search;

    useEffect(() => {
        AppCapacitorPlugin.addListener('appUrlOpen', (event) => {            
            const divider = event.url.match(/https:\/\/(dev|staging|app)\.hanufit\.com|hanufit:\/(\/localhost)?/)?.[0]
            const slug = event.url.split(divider)[1]

            if (slug) {
                window.location.href = `${window.location.origin}${slug}`
            }
            // If no match, do nothing - let regular routing
            // logic take over
        });

        return () => AppCapacitorPlugin.removeAllListeners()
    }, []);

    const openUrl = async (partner, queryString) => {
        window.location = partnersService.redirectToAuth(partner, queryString)
    }

    useEffect(() => {
        console.log("PARTNER: ", partner)
        if (partner?.length > 0) {
            openUrl(partner, queryString)
        }
    }, [partner, queryString]);

    return (
        <div className='partners-wrapper'>
            <PartnerLoadingSpinner partner={partner} />
        </div>
    );

}
export default Partners;
